module.exports = __webpack_public_path__ + "img/book-skull.8e8fe39c.svg";